import React from 'react';
import { Link } from 'react-router';
import ReviewsAggMetadata from 'marketing/containers/reviews_agg_metadata';
import StarRatingPartial from 'marketing/components/star_rating_partial';

const ReviewsAgg = ({ stats, itemName, itemDescription, title }) => (
  <div className="reviews-agg">
    <ReviewsAggMetadata itemName={itemName} itemDescription={itemDescription} />
    { title ||
    <h2>
      Loved by over 60,000 businesses <span className="show-for-small-only">worldwide.</span>
      <span className="show-for-medium"> around the world.</span>
    </h2> }
    <StarRatingPartial rating={stats.avg || 0} />
    <h3 className="as-h4-important">
      crowdspring is rated { stats.avg || 0 }/5 from { (stats.count || 0).toLocaleString() }{' '}
      <Link to="/reviews/">customer reviews</Link>.
    </h3>
  </div>
);

export default ReviewsAgg;
